const _window = window;
function getDescriptionContent(variantId) {
    if (!_window.variantMetafields)
        return '';
    const variantData = _window.variantMetafields[variantId];
    return (variantData === null || variantData === void 0 ? void 0 : variantData.description) || '';
}
function getNutritionContent(variantId) {
    var _a;
    if (!_window.variantMetafields)
        return '';
    const variantData = _window.variantMetafields[variantId];
    return ((_a = variantData === null || variantData === void 0 ? void 0 : variantData.nutrition_info) === null || _a === void 0 ? void 0 : _a.html) || '';
}
function getIngredientsContent(variantId) {
    if (!_window.variantMetafields)
        return '';
    const variantData = _window.variantMetafields[variantId];
    return (variantData === null || variantData === void 0 ? void 0 : variantData.ingredients) || '';
}
function getBenefitsContent(variantId) {
    if (!_window.variantMetafields)
        return '';
    const variantData = _window.variantMetafields[variantId];
    return (variantData === null || variantData === void 0 ? void 0 : variantData.benefits) || '';
}
function getHowToUseContent(variantId) {
    if (!_window.variantMetafields)
        return '';
    const variantData = _window.variantMetafields[variantId];
    return (variantData === null || variantData === void 0 ? void 0 : variantData.how_to_use) || '';
}
export const ContentHelper = {
    getDescriptionContent,
    getNutritionContent,
    getIngredientsContent,
    getBenefitsContent,
    getHowToUseContent,
};
